module.exports = __webpack_public_path__ + "static/media/bg-lines.f0de98e6.png";